import { Chip, Stack } from "@mui/material";

import { MailAccount } from "api/memberPortal/mailList/mailList.types";

interface AddMemberChipsProps {
  selectedMembers: MailAccount[];
  onRemove: (_userId: number) => void;
}

export default function AddMemberChips({
  selectedMembers,
  onRemove,
}: AddMemberChipsProps) {
  if (selectedMembers.length === 0) return null;

  return (
    <Stack
      direction="row"
      flexWrap="wrap"
      gap={0.5}
      sx={{
        pt: 1,
        maxHeight: 100,
        overflowY: "auto",
      }}
    >
      {selectedMembers.map((member) => (
        <Chip
          key={member.id}
          label={member.name}
          size="small"
          onDelete={() => onRemove(member.id)}
          color="navy"
        />
      ))}
    </Stack>
  );
}
